import gql from 'graphql-tag';
import { ATTACHMENT_FIELDS } from './projectDocumentsFragment';

/**
 * Data of the block project-service-report-build ("Service: Bericht generieren"): the generated
 * PDF, the ZIP of the service photos and their build states. Read through
 * `Project.blocks.serviceReportBuild`, which checks the block's read permission.
 */
export const PROJECT_SERVICE_REPORT_BUILD_FIELDS = gql`
  fragment projectServiceReportBuildFields on ProjectServiceReportBuildBlock {
    id
    number
    serviceReportAttachments {
      ${ATTACHMENT_FIELDS}
    }
    serviceReportAttachmentsBuildState
    serviceReportImageAttachmentsZip {
      ${ATTACHMENT_FIELDS}
    }
    serviceReportImageAttachmentsZipBuildState
  }
`;
